<template>
    <div>
        <div id="map" style="width: 4rem; height: 2.5rem;"></div>
    </div>
</template>

<script>
    import * as bmap from 'bmap'
    
    export default {
        name: 'BaiduMapComponent',
        data() {
            return {
                
            }
        },
        mounted() {
            this.initMap()
        },
        methods: {
            initMap() {
                const map = new BMap.Map('map') // 创建Map实例
                const point = new BMap.Point(103.866132,36.047336) // 创建点坐标  	103.858869,36.041125
                map.centerAndZoom(point, 16) // 初始化地图,设置中心点坐标和地图级别
                map.enableScrollWheelZoom(true); 
                map.setCenter(point);  // 设置中心点图标样式

                // 添加中心点图标
                const marker = new BMap.Marker(point);
                map.addOverlay(marker);
            }
        },
        components: {
        	
        }
    }
</script>

<style>
    
</style>